var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import WallBuilderApp from './WallBuilderApp';
import SbThemeProvider from '@components/theme/provider';
import AppProvider from '@components/Shared/State/provider';
export { default } from './WallBuilderApp';
export { default as WallBuilderApp } from './WallBuilderApp';
export { default as WallBuilder } from './WallBuilder';
export { default as WallPreview } from './WallPreview';
export const LoadWallBuilder = (element) => __awaiter(void 0, void 0, void 0, function* () {
    const root = createRoot(element);
    root.render(_jsx(AppProvider, { children: _jsx(SbThemeProvider, { children: _jsx(WallBuilderApp, {}) }) }));
});
